import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import SEO from "@/components/SEO";
import HeroSlideshow from "@/components/public/HeroSlideshow";

export default function Home() {
  const [settings, setSettings] = useState({});
  const [artworks, setArtworks] = useState([]);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
    api.get("/artworks", { params: { sort: "newest" } }).then(({ data }) => {
      const feat = data.filter((a) => a.featured);
      setArtworks((feat.length ? feat : data).slice(0, 6));
    }).catch(() => {});
  }, []);

  const heroImages = artworks.map((a) => a.main_image).filter(Boolean);

  return (
    <div className="fade-in">
      <SEO description={settings.intro_text} image={mediaUrl(settings.hero_image)} />

      {/* Hero — veredeltes Violett, einzige Sektion der Startseite */}
      <section className="on-dark violet-canvas relative overflow-hidden flex-1 w-full">
        {/* weiche Lichthöfe in violetten Tönen */}
        <div className="violet-orb -top-32 -left-24 w-[28rem] h-[28rem] bg-[#9A4DCC] opacity-30" />
        <div className="violet-orb top-1/3 -right-20 w-[24rem] h-[24rem] bg-[#D85CA4] opacity-25" style={{ animationDelay: "3s" }} />
        <div className="violet-orb bottom-0 left-1/3 w-[22rem] h-[22rem] bg-[#F4C542] opacity-10" style={{ animationDelay: "6s" }} />

        <div className="relative mx-auto max-w-7xl px-5 sm:px-8 min-h-[calc(100vh-72px)] flex items-center py-16 sm:py-20">
          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center w-full">
            <div className="order-2 md:order-1">
              <div className="text-xs uppercase tracking-[0.3em] text-[#F4C542] mb-6">{settings.tagline || "Kunst & Poesie"}</div>
              <h1 className="font-serif text-6xl sm:text-7xl lg:text-8xl font-light leading-[0.95] text-[#FFF9F2]">
                Kunst,<br />die berührt<span className="text-[#F4C542]"> </span>
                <span className="text-[#F4C542]">·</span>
              </h1>
              <p className="mt-8 text-lg text-[#D8B9EA] leading-relaxed max-w-md">
                {settings.hero_text || "Willkommen in meiner digitalen Galerie – ein ruhiger Raum für Gemälde, Bilder und Gedichte von Susanne Monika Gysin."}
              </p>
              <div className="mt-10 flex flex-wrap gap-4">
                <Link
                  to="/galerie"
                  data-testid="hero-cta-gallery"
                  className="inline-flex items-center gap-2 bg-[#F4C542] text-[#32104F] font-medium px-8 py-4 text-sm tracking-wide hover:bg-[#D85CA4] hover:text-[#FFF9F2] transition-colors rounded-md"
                >
                  Kunst entdecken <ArrowRight className="w-4 h-4" strokeWidth={2} />
                </Link>
                <Link
                  to="/gedichte"
                  data-testid="hero-cta-poems"
                  className="inline-flex items-center gap-2 border border-[#D8B9EA] text-[#FFF9F2] px-8 py-4 text-sm tracking-wide hover:bg-[#D8B9EA] hover:text-[#32104F] transition-colors rounded-md"
                >
                  Gedichte lesen
                </Link>
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="ring-1 ring-[#F4C542]/30 p-2 rounded-md backdrop-blur-[2px] bg-white/[0.03]">
                <HeroSlideshow imageIds={heroImages.length ? heroImages : [settings.hero_image].filter(Boolean)} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
